<template>
    <div>
        <div class="mb-2 flex items-center justify-between">
            <button
                type="button"
                @click="$emit('update:modelValue', !modelValue)"
                class="flex items-center space-x-2 font-bold text-white"
            >
                <span>{{ title }}</span>
                <svg
                    :class="['size-4 transition-transform', modelValue ? 'rotate-180' : '']"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                >
                    <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                    />
                </svg>
            </button>
            <span class="font-bold text-white">{{ count }}</span>
        </div>

        <div v-if="modelValue" class="space-y-2">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'AccordionSection',
    props: {
        title: {
            type: String,
            required: true,
        },
        count: {
            type: Number,
            default: 0,
        },
        modelValue: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['update:modelValue'],
}
</script>
